import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "availibilityFilterByUser",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered modal-extra-large modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TostCalender = _resolveComponent("TostCalender")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('check_availability_of')) + " " + _toDisplayString(_ctx.selectedEmail), 1),
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideAvaibilityModal && _ctx.hideAvaibilityModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            (_ctx.state.ui.isLoading.availabilityCheck)
              ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('loading1')), 1))
              : (_openBlock(), _createBlock(_component_TostCalender, {
                  key: 1,
                  slots: _ctx.userDetails.filteredSlots,
                  activeTab: _ctx.activeTab,
                  activeComponent: 'timeslot',
                  phaseDetails: _ctx.phaseDetails,
                  activePhaseId: _ctx.activePhaseId,
                  selectedEmail: _ctx.selectedEmail,
                  startDate: _ctx.startDate,
                  endDate: _ctx.endDate,
                  from: _ctx.from,
                  onHideCheckAvaibilityModal: _ctx.hideCheckAvaibilityModal
                }, null, 8, ["slots", "activeTab", "phaseDetails", "activePhaseId", "selectedEmail", "startDate", "endDate", "from", "onHideCheckAvaibilityModal"]))
          ])
        ])
      ])
    ])
  ]))
}